import React from 'react';
import '../styles/MainContainer.css';
import './Documentation.css';
import MarkdownRenderer from './MarkdownRenderer';
import OfflineBanner from '../shell/OfflineBanner';

function DocsPage({ doc }) {
  return (
    <main className="defaultExtendedMain docs-main">
      <OfflineBanner />
      <div className="docs-container">
        <MarkdownRenderer markdown={doc} />
      </div>
    </main>
  );
}

export default DocsPage;
